@import '../../../../../../../../constants/spacing.module.less';

.back-btn {
  display: flex;
  align-items: center;
}

.icon {
  width: 14px;
  margin-right: @space-8;
}

.continue-btn {
  margin-left: auto;
}
